import React, { useState } from 'react';
import { QrCodeIcon, TicketIcon, ClockIcon, CheckCircleIcon, CrownIcon, CheckIcon } from 'lucide-react';
import GlassCard from '../ui/GlassCard';
import Button from '../ui/Button';
const Wallet: React.FC = () => {
  const [showQR, setShowQR] = useState(false);
  const points = 450;
  const redemptions = [{
    id: 1,
    location: 'Eco Café',
    date: 'Today',
    points: 50,
    status: 'active'
  }, {
    id: 2,
    location: 'Fitness Center',
    date: 'Yesterday',
    points: 30,
    status: 'used'
  }, {
    id: 3,
    location: 'Green Hotel',
    date: 'May 15',
    points: 100,
    status: 'used'
  }];
  return <div className="h-full bg-[#1A237E] pt-12 pb-24 px-4 overflow-y-auto" data-id="element-1441">
      <header className="mb-6" data-id="element-1442">
        <h1 className="text-2xl font-bold text-white font-gt-ultra" data-id="element-1443">
          Rewards Wallet
        </h1>
        <p className="text-[#00E4BB] font-gill-sans" data-id="element-1444">
          Earn & redeem as you hydrate
        </p>
      </header>
      {/* Hydration Club */}
      <div className="mb-6" data-id="element-1445">
        <GlassCard className="p-4 border-2 border-[#00E4BB]" data-id="element-1446">
          <div className="flex items-center mb-4" data-id="element-1447">
            <div className="w-12 h-12 bg-[#00E4BB] rounded-full flex items-center justify-center mr-4" data-id="element-1448">
              <CrownIcon className="w-6 h-6 text-[#1A237E]" data-id="element-1449" />
            </div>
            <div data-id="element-1450">
              <h3 className="text-xl font-bold text-[#FAFAFA] font-gt-ultra" data-id="element-1451">
                The Hydration Club
              </h3>
              <p className="text-[#00E4BB]" data-id="element-1452">Unlimited Smart Soda Access</p>
            </div>
          </div>
          <div className="space-y-2 mb-4" data-id="element-1453">
            <div className="flex items-center" data-id="element-1454">
              <CheckIcon className="w-5 h-5 text-[#00E4BB] mr-2" data-id="element-1455" />
              <p className="text-[#FAFAFA]" data-id="element-1456">
                Unlimited refills at all locations
              </p>
            </div>
            <div className="flex items-center" data-id="element-1457">
              <CheckIcon className="w-5 h-5 text-[#00E4BB] mr-2" data-id="element-1458" />
              <p className="text-[#FAFAFA]" data-id="element-1459">Exclusive Smart Tumbler included</p>
            </div>
            <div className="flex items-center" data-id="element-1460">
              <CheckIcon className="w-5 h-5 text-[#00E4BB] mr-2" data-id="element-1461" />
              <p className="text-[#FAFAFA]" data-id="element-1462">
                2x rewards points on all purchases
              </p>
            </div>
          </div>
          <Button variant="primary" fullWidth data-id="element-1463">
            Join the Club - $29.99/month
          </Button>
        </GlassCard>
      </div>
      {/* Points Card */}
      <GlassCard className="mb-6 p-4" data-id="element-1464">
        <div className="flex items-center" data-id="element-1465">
          <div className="w-16 h-16 rounded-full bg-[#1A237E]/50 border-4 border-[#A6FF4D] flex items-center justify-center mr-4" data-id="element-1466">
            <span className="text-xl font-bold text-[#A6FF4D]" data-id="element-1467">{points}</span>
          </div>
          <div data-id="element-1468">
            <h3 className="text-white font-bold" data-id="element-1469">Available Points</h3>
            <p className="text-sm text-gray-300" data-id="element-1470">50 points until next reward</p>
            <div className="mt-2 h-1.5 bg-[#1A237E]/50 rounded-full overflow-hidden w-32" data-id="element-1471">
              <div className="h-full bg-gradient-to-r from-[#00E4BB] to-[#A6FF4D]" style={{
              width: `${Math.min(points % 500 / 500 * 100, 100)}%`
            }} data-id="element-1472"></div>
            </div>
          </div>
        </div>
      </GlassCard>
      {/* QR Code Section */}
      <div className="mb-6" data-id="element-1473">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-1474">Drink & Earn</h2>
        {showQR ? <div className="bg-white p-6 rounded-2xl flex flex-col items-center" data-id="element-1475">
            <div className="w-48 h-48 bg-[#1A237E] mb-4 flex items-center justify-center" data-id="element-1476">
              {/* Placeholder for QR code */}
              <QrCodeIcon className="w-32 h-32 text-white" data-id="element-1477" />
            </div>
            <p className="text-[#002B36] font-medium text-center" data-id="element-1478">
              Show this QR code at any Smart Soda fountain
            </p>
            <Button variant="outline" className="mt-4 border-[#002B36] text-[#002B36]" onClick={() => setShowQR(false)} data-id="element-1479">
              Hide Code
            </Button>
          </div> : <Button fullWidth className="py-6 text-lg" onClick={() => setShowQR(true)} data-id="element-1480">
            <QrCodeIcon className="w-6 h-6 mr-2" data-id="element-1481" />
            Generate QR Code
          </Button>}
      </div>
      {/* Available Rewards */}
      <div className="mb-6" data-id="element-1482">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-1483">Available Rewards</h2>
        <div className="grid grid-cols-2 gap-3" data-id="element-1484">
          <GlassCard className="p-3" data-id="element-1485">
            <div className="w-10 h-10 rounded-full bg-[#A6FF4D]/20 flex items-center justify-center mb-2" data-id="element-1486">
              <TicketIcon className="w-5 h-5 text-[#A6FF4D]" data-id="element-1487" />
            </div>
            <h3 className="text-white font-medium text-sm" data-id="element-1488">Free Refill</h3>
            <p className="text-xs text-gray-300 mb-2" data-id="element-1489">Any size, any flavor</p>
            <Button size="sm" fullWidth data-id="element-1490">
              Redeem (200 pts)
            </Button>
          </GlassCard>
          <GlassCard className="p-3" data-id="element-1491">
            <div className="w-10 h-10 rounded-full bg-[#00E4BB]/20 flex items-center justify-center mb-2" data-id="element-1492">
              <TicketIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-1493" />
            </div>
            <h3 className="text-white font-medium text-sm" data-id="element-1494">50% Off</h3>
            <p className="text-xs text-gray-300 mb-2" data-id="element-1495">Next purchase</p>
            <Button size="sm" fullWidth data-id="element-1496">
              Redeem (100 pts)
            </Button>
          </GlassCard>
        </div>
      </div>
      {/* Redemption History */}
      <div data-id="element-1497">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-1498">History</h2>
        <div className="space-y-3" data-id="element-1499">
          {redemptions.map(item => <GlassCard key={item.id} className="p-3 flex items-center" data-id="element-1500">
              <div className={`w-10 h-10 rounded-full ${item.status === 'active' ? 'bg-[#00E4BB]/20' : 'bg-gray-500/20'} flex items-center justify-center mr-3`} data-id="element-1501">
                {item.status === 'active' ? <ClockIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-1502" /> : <CheckCircleIcon className="w-5 h-5 text-gray-400" data-id="element-1503" />}
              </div>
              <div className="flex-1" data-id="element-1504">
                <h3 className="text-white font-medium text-sm" data-id="element-1505">
                  {item.location}
                </h3>
                <p className="text-xs text-gray-300" data-id="element-1506">{item.date}</p>
              </div>
              <div className="text-right" data-id="element-1507">
                <p className={`font-medium ${item.status === 'active' ? 'text-[#00E4BB]' : 'text-gray-400'}`} data-id="element-1508">
                  +{item.points} pts
                </p>
                <p className="text-xs text-gray-300" data-id="element-1509">
                  {item.status === 'active' ? 'Active' : 'Used'}
                </p>
              </div>
            </GlassCard>)}
        </div>
      </div>
    </div>;
};
export default Wallet;